import React from 'react';
import { Box, Typography, Card, CardContent, Chip } from '@mui/material';
import { Assessment as AssessmentIcon } from '@mui/icons-material';

const ApplicationStatusCard = ({ application }) => {
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'accepted':
        return 'success';
      case 'rejected':
        return 'error';
      case 'interview':
        return 'warning';
      case 'submitted':
        return 'info';
      default:
        return 'default';
    }
  };

  if (!application) return null;

  return (
    <Card sx={{ mb: 3, border: '1px solid #e0e0e0' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <AssessmentIcon sx={{ color: 'primary.main', mr: 1 }} />
          <Typography variant="h6" fontWeight="bold">
            Application Status
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', mb: 2 }}>
          <Chip
            label={application.status}
            color={getStatusColor(application.status)}
            sx={{ fontWeight: 600 }}
          />
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Applied on: {new Date(application.created_at).toLocaleDateString()}
          </Typography>
        </Box>
        
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Resume Used: {application.user_resume.resume_name}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ApplicationStatusCard;